export const config = {
  baseURL: "http://detoner777.github.io/imba-eshop",
  products: "/products",
  pageSize: 12,
  delay: 0,
};
